<template>
  <div class="xs12 flex mx-1">
    <v-flex 
      style="background-color: #392939; line-height: 23px; height:30px; border-radius: 4px; " 
      class="white--text text-uppercase body-2 elevation-0 pl-3 mx-1 pt-1"
    >
    <!-- line-height: 28px;"
      class="pl-3 xs12 "
    > -->
      <!-- <v-flex
        class="xs12"
        style="font-size: 14px; text-weigth: 100; height: 28px;"
      > -->
        <span>{{ text }}</span>
        <v-btn round light target="_blank" small flat
          color="white"
          @click="showAdd"
          style="text-decoration: none !important; height:30px; background-color:#392939;"
          class="black--text right mt-0 mr-2 mb-0 pl-1 pr-2 xs12" rel="noopener noreferrer">
          <v-icon small color="white" class="mr-2">add</v-icon>
          Add new Link
        </v-btn>
      <!-- </v-flex> -->
    </v-flex>
  </div>
</template>

<script>
export default {
  props: ['text'],
  methods: {
    showAdd () {
      this.$emit('showAdd')
    }
  }
}
</script>

<style lang="css" scoped>
.v-btn--small {
  height: 22px !important;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/SubSectionHeader.vue